/**
 * Input component
 *
 * Optional props:
 * disabled : boolean
 * checked : boolean
 * label : string - Label of checkbox that is placed beside checkbox
 * meta : object - redux form meta data
 * input : object - redux form input data
 * large : boolean - add large size
 *
 * Examples of component:
 * <Checkbox />
 * <Checkbox disabled />
 * <Checkbox checked label="The label text" />
 * <Checkbox checked disabled />
 *
 */

import React from 'react';
import styled from 'styled-components';
import { colors } from '../../variables';
import { Label } from '../../Common';
import checkedIcon from '../../../images/checked_white.svg';

const getSize = props => {
	if (props.large) return '18px';

	return '14px';
};

const Container = styled.div`
	display: flex;
	align-items: center;
`;

const CheckboxContainer = styled.div`
	display: inline-block;
`;

const disabledColor = '#cecfcf';

const CheckboxInput = styled.input`
	display: none;

	+ span {
		width: ${props => getSize(props)};
		height: ${props => getSize(props)};
		background-color: #fff;
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
		border: 3px solid ${colors.grey.graphite};
		transition: all 0.2s ease-out;
		display: block;
		cursor: pointer;
		-webkit-print-color-adjust: exact;
	}

	&:checked + span {
		background-color: ${colors.blue.digital};
		background-image: url(${checkedIcon});
		border-color: ${colors.blue.digital};
	}

	&:disabled + span {
		border-color: ${disabledColor};
		cursor: auto;
	}

	&:disabled:checked + span {
		background-color: ${disabledColor};
		background-image: url(${checkedIcon});
		border-color: ${disabledColor};
	}
`;

class Checkbox extends React.Component {
	render() {
		const { className, label, name = false, input = {}, ...rest } = this.props;

		const nameValue = input.name || name;

		return (
			<Container className={className}>
				<CheckboxContainer className={className}>
					<label>
						<CheckboxInput
							type="checkbox"
							{...rest}
							name={nameValue}
							{...input}
						/>
						<span />
					</label>
				</CheckboxContainer>

				{label && (
					<Label htmlFor={nameValue} className="ml5">
						{label}
					</Label>
				)}
			</Container>
		);
	}
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Common/Checkbox/Checkbox.js